import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {ISupplier, TableSettings} from "features/suppliers";

interface Props extends Omit<ListItemsTableProps<
    ISupplier & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<ISupplier>[]
}

export function SuppliersListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}